import {
  utcDay as d3_utcDay,
  utcWeek as d3_utcWeek,
  utcMonth as d3_utcMonth,
  utcYear as d3_utcYear,
  utcMinute as d3_utcMinute,
} from 'd3-time'
import { timeInterval as d3_timeInterval } from 'd3-time'
const utcFort = d3_timeInterval(
  date => {
    // date.setUTCHours(0, 0, 0, 0);
    date.getUTCDate() >= 15 ? date.setUTCDate(15) : date.setUTCDate(1)
    date.setUTCHours(0, 0, 0, 0)
  },
  (date, step) => {
    date.setUTCMonth(date.getUTCMonth() + Math.floor(step / 2))
    if (step % 2 === 1) {
      if (date.getUTCDate() < 15) date.setUTCDate(15)
      else {
        date.setUTCMonth(date.getUTCMonth() + 1)
        date.setUTCDate(1)
      }
    }
    // date.getUTCDate()>=8 && date.getUTCDate()<18?date.setUTCDate(15):date.setUTCDate(1)
  },
  (start, end) => {
    return (
      (end.getUTCYear() - start.getUTCYear()) * 24 +
      (end.getUTCMonth() - start.getUTCMonth()) * 2 +
      Math.floor((end.getUTCDate() - start.getUTCDate()) / 15) * 15
    )
  },
  date => {
    return date.getUTCDate() - 1
  }
)
const INTERVALS = {
  day: [d3_utcDay.every(1), utcFort.every(1)],
  month: [d3_utcMonth.every(1), d3_utcMonth.every(3), d3_utcMonth.every(6)],
  quarter: [d3_utcMonth.every(3), d3_utcMonth.every(6)],
  year: [d3_utcYear.every(1), d3_utcYear.every(2), d3_utcYear.every(5), d3_utcYear.every(10)],
}

export function computeAutoTicks(data, scale, format) {
  let intervals
  if (format.toLowerCase().indexOf('%d') >= 0)
    intervals = [...INTERVALS['day'], ...INTERVALS['month'], ...INTERVALS['year']]
  else if (format.toLowerCase().indexOf('%b') >= 0 || format.toLowerCase().indexOf('%B') >= 0)
    intervals = [...INTERVALS['month'], ...INTERVALS['year']]
  else if (format.toLowerCase().indexOf('%q') >= 0)
    intervals = [...INTERVALS['quarter'], ...INTERVALS['year']]
  else if (format.toLowerCase().indexOf('%y') >= 0) intervals = [...INTERVALS['year']]
  let ticks
  let int = 0

  //console.log(scale.ticks.apply(scale, [utcFort.every(1)]))
  while ((!ticks || ticks.length > 14) && int < intervals.length) {
    ticks = scale.ticks.apply(scale, [intervals[int]])
    int++
  }

  return ticks
}
